<template>
  <div>
    <menu-pae :inFocus="false">
      <template>
        <div id="menuMesagem">
          <div class="acoes">
            <button class="btn btn-danger" @click.prevent="voltar"> Voltar </button>
          </div>
        </div>
      </template>
    </menu-pae>
    <div id="wrapper">
      <div id="content-wrapper" class="d-flex flex-column mt-2">
        <div id="content">
          <div class="container-fluid mt-3">
            <div class="card-columns row justify-content-md-center">
              <div
                v-for="menu in menus"
                :key="menu.title + menu.number"
                :class="`${menu.column} mb-4`"
                :id="menu.id"
              >
                <div>
                  <div :class="`h-100 py-2 card shadow ${menu.borderCard}`">
                    <div class="card-body">
                      <div class="row no-gutters">
                        <a :class="`${menu.disable ? 'disable' : ''} link col mr-2 text-center w-100`" routerLink="#" @click="navegar(menu.rota, menu.title)">
                          <titleComp
                            :icon="menu.icon"
                            :title="menu.title"
                            :color="menu.disable ? '#DCDCDC' : menu.color"
                            :isMenu="false"
                            :selected="isSelected(menu.title)"
                            :svg="menu.svg"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/scss/custom.css'
import titleComp from '@/components/home/title.vue'
import { componentIsVisible, rules } from '@/uteis/action/permissao'
import menuPae from '@/components/Menu.vue'

export default {
  name: 'work-area-admin',

  components: {
    titleComp,
    menuPae
  },

  data () {
    return {
      nome: '',
      isMenu: false,
      selected: ''
    }
  },

  computed: {
    menus () {
      return [{
        title: 'Caixa de Mensagem',
        icon: 'fa fa-commenting-o',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        subtitleColor: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/caixa',
        hasNumber: false,
        column: 'col-md-5 col-sm-12',
        svg: 'mensagem',
        id: 'mensagem',
        disable: !this.caixaDeMensagemIsVisible()
      }, {
        title: 'Estruturas Inativas',
        icon: 'fa fa-commenting-o',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        subtitleColor: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/estrutura/inativa',
        hasNumber: false,
        column: 'col-md-5 col-sm-12',
        svg: 'inativar-strutura',
        id: 'inativar-strutura',
        disable: !this.inativarEstruturaIsVisible()
      }]
    }
  },

  methods: {
    navegar (url, title) {
      this.selected = title

      try {
        this.$router.push({ path: url })
      } catch (error) {
        console.log(error)
      }
    },

    isSelected (title) {
      return this.selected === title
    },

    caixaDeMensagemIsVisible () {
      const { CRIAR_ALERTA } = rules
      return componentIsVisible(CRIAR_ALERTA)
    },

    inativarEstruturaIsVisible () {
      const { INATIVAR_ESTRUTURA } = rules
      return componentIsVisible(INATIVAR_ESTRUTURA)
    },

    voltar () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang='scss'>
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div{
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;
  &--primary {
    background-color: green;
    color: #fff;
  }
  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
